import React, { useEffect, useRef, useState } from 'react'
import { Col, Modal, OverlayTrigger, Row, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import { addCustomerAddress, getCustomerCities, getCustomerCountries, getCustomerStates } from 'utlis/Apis/Customers_API';
import { toast } from 'react-toastify';
import { ADDRESS_ADDED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_CREATING_ADDRESS } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { useFormik } from 'formik';
import { addressFormValues, addressFormVS } from './Helper';


function AddShippingAddressModal(props) {
    const { authState, showAddNewAddressModal, closeAddNewAddressModal, customer, getAddresses } = props
    const [modalLoading, setModalLoading] = useState(false)
    const submitButtonRef = useRef(null)
    const [createButtonDisable, setCreateButtonDisable] = useState(false)
    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    useEffect(() => {
        getCountries_()
    })

    const getCountries_ = () => {
        if (countries.length === 0) {
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            getCustomerCountries(headers).then(res => {
                const countriesData = res.data

                if (countriesData.success) {
                    setCountries(countriesData.data)
                }

                if (countriesData.error) {
                    console.log('Error occured while loading admin groups!', res)
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })
        }
    }

    const getStates_ = (country_id) => {
        setStates([])
        setCities([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerStates(headers, country_id).then(res => {
            const stateData = res.data
            if (stateData.success) {
                setStates(stateData.data)
            }

            if (stateData.error) {
                console.log('Error occured while loading states!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getStates `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const getCities_ = (region_id) => {
        setCities([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerCities(headers, region_id).then(res => {
            const cityData = res.data
            if (cityData.success) {
                setCities(cityData.data)
            }

            if (cityData.error) {
                console.log('Error occured while loading cities!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCities `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
            })
        })
    }
    const onCreateFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setCreateButtonDisable(true)
            setModalLoading(true)
            values.user_id = customer.user_id
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            addCustomerAddress(headers, values).then(res => {
                setGlobalLoading(false)

                const addingCustomerGroup = res.data
                if (addingCustomerGroup.success) {
                    getAddresses()
                    setModalLoading(false)
                    setCreateButtonDisable(false)
                    window.scrollTo(0, 0)
                    formik.resetForm()
                    toast.dismiss();
                    toast.success(ADDRESS_ADDED_SUCCESSFULLY, {
                        autoClose: 2000,
                        onClose: () => { }

                    })
                    closeAddNewAddressModal(!showAddNewAddressModal)
                }
                if (addingCustomerGroup.error) {
                    console.log(ERROR_WHILE_CREATING_ADDRESS, res)
                    setCreateButtonDisable(false)
                    setModalLoading(false)
                    toast.dismiss();
                    toast.error(ERROR_WHILE_CREATING_ADDRESS, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setGlobalLoading(false)
                        setCreateButtonDisable(false)
                        setModalLoading(false)
                    }
                })
            })
        }
    }

    const formik = useFormik({
        initialValues: addressFormValues(customer),
        validationSchema: addressFormVS,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }

    return (
        <Modal show={showAddNewAddressModal} onHide={closeAddNewAddressModal} centered size="lg">
            <Modal.Body className="st-modal pad-20">
                <form
                    onSubmit={formik.handleSubmit}
                    noValidate
                    autoComplete="off">
                    <div className="app-modal-content modal-add-product p-0">
                        <div className="add-product-form">
                            <div className="d-flex justify-content-between">
                                <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                    <p className="app-modal-title text-capitalize st-fw-600 st-fs-24">Add New Address</p>
                                </div>
                                <OverlayTrigger
                                    placement={"bottom"}
                                    overlay={renderTooltipClose}
                                >
                                    <button
                                        className="st-round-btn st-btn-transparent  st-btn-sm d-flex align-items-center justify-content-center"
                                        onClick={props.closeAddNewAddressModal && props.closeAddNewAddressModal}
                                    >
                                        <FeatherIcon
                                            icon="x"
                                            size="24"
                                            className="icon border st-default-rounded-block" />
                                    </button>
                                </OverlayTrigger>
                            </div>
                            <div className="app-card customer-product-modal">
                                <div className="app-card-content border st-default-rounded-block pad-20" style={{ backgroundColor: '#F7F9FA' }}>
                                    <div className="st-form flex-wrap mb-0">
                                        {/* <AppFormikSelectInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"Address Type"}
                                            isRequired={true}
                                            formikFieldName={"address_type"}
                                        >
                                            <option disabled value="">Select Address Type</option>
                                            <option value="Shipping">Shipping</option>
                                            <option value="Billing">Billing</option>
                                        </AppFormikSelectInline> */}

                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"First Name"}
                                            isRequired={true}
                                            placeholder={"First Name"}
                                            formikFieldName={"shipping_first_name"}
                                        />

                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"Middle Name"}
                                            isRequired={false}
                                            placeholder={"Middle Name"}
                                            formikFieldName={"shipping_middle_name"}
                                        />

                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"Last Name"}
                                            isRequired={true}
                                            placeholder={"Last Name"}
                                            formikFieldName={"shipping_last_name"}
                                        />

                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"Company Name"}
                                            isRequired={true}
                                            placeholder={"Company Name"}
                                            formikFieldName={"shipping_company_name"}
                                        />
                                        <Row className="d-flex justify-content-end">
                                            <Col xs={12} md={12} lg={9} className="me-3  pad-20-L">
                                                <div className="border-bottom st-border-light" />
                                            </Col>
                                        </Row>
                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center pad-20-T mb-1"}
                                            labelName={"Street Address"}
                                            isRequired={true}
                                            placeholder={"Street Address1"}
                                            formikFieldName={"shipping_address"}
                                        />

                                        <Row className="justify-content-end">
                                            <Col xs={12} md={12} lg={9}>
                                                <AppFormikInputInline
                                                    formik={formik}
                                                    stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                                    labelName={""}
                                                    isRequired={false}
                                                    placeholder={"Street Address2"}
                                                    formikFieldName={"shipping_address1"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="d-flex justify-content-end">
                                            <Col xs={12} md={12} lg={9} className="me-3 pad-20-L">
                                                <div className="border-bottom st-border-light" />
                                            </Col>
                                        </Row>
                                        <AppFormikSelectInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center pad-20-T "}
                                            labelName={"Country"}
                                            isRequired={true}
                                            formikFieldName={"shipping_country"}
                                            onChange={(country) => {
                                                getStates_(country)
                                                formik.setFieldValue("shipping_state", "")
                                                formik.setFieldValue("shipping_city", "")
                                                formik.setFieldValue("country", (countries.find(e => e.country_id === parseInt(country)) || {}).country)
                                            }}
                                            disabled={countries.length === 0}
                                        >
                                            <option disabled value="">Select Country</option>
                                            {(countries && countries.length) && countries.map(item => (
                                                <option
                                                    key={item.country_id.toString()}
                                                    value={item.country_id.toString()}>{item.country}</option>
                                            ))
                                            }
                                        </AppFormikSelectInline>

                                        <AppFormikSelectInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"State/Provience"}
                                            isRequired={true}
                                            formikFieldName={"shipping_state"}
                                            onChange={(state) => {
                                                getCities_(state)
                                                formik.setFieldValue("shipping_city", "")
                                                formik.setFieldValue("state", (states.find(e => e.region_id === parseInt(state)) || {}).region)
                                            }}
                                            disabled={states.length === 0}
                                        >
                                            <option disabled value="">Select State</option>
                                            {(states && states.length) && states.map(item => (
                                                <option
                                                    key={item.region_id.toString()}
                                                    value={item.region_id.toString()}>{item.region}</option>
                                            ))
                                            }
                                        </AppFormikSelectInline>

                                        <AppFormikSelectInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"City"}
                                            isRequired={true}
                                            formikFieldName={"shipping_city"}
                                            disabled={cities.length === 0}
                                            onChange={(city) => {
                                                formik.setFieldValue("city", (cities.find(e => e.city_id === parseInt(city)) || {}).city)
                                            }}

                                        >
                                            <option disabled value="">Select City</option>
                                            {(cities && cities.length) && cities.map(item => (
                                                <option
                                                    key={item.city_id.toString()}
                                                    value={item.city_id.toString()}>{item.city}</option>
                                            ))
                                            }
                                        </AppFormikSelectInline>

                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                                            labelName={"Zip/Postal Code"}
                                            isRequired={false}
                                            inputType={"number"}
                                            placeholder={"ZipCode"}
                                            formikFieldName={"shipping_zipcode"}
                                        />

                                        {/* <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"Phone Number"}
                                            inputType="phone"
                                            isRequired={false}
                                            placeholder={"Phone"}
                                            formikFieldName={"shipping_phone"}

                                        /> */}
                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-1"}
                                            labelName={"Mobile"}
                                            inputType="phone"
                                            isRequired={true}
                                            placeholder={"Mobile"}
                                            formikFieldName={"shipping_mobile"}
                                        />

                                        <AppFormikInputInline
                                            formik={formik}
                                            stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                                            labelName={"Fax"}
                                            isRequired={false}
                                            placeholder={"Fax"}
                                            inputType={"number"}
                                            formikFieldName={"shipping_fax"}
                                        />
                                        <div className="app-card-content st-border-light d-flex align-items-center justify-content-end">
                                            <button
                                                type="submit"
                                                className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2`}
                                                disabled={createButtonDisable}
                                                onClick={() =>
                                                    (formik.resetForm())}
                                            >
                                                <FeatherIcon
                                                    icon="rotate-ccw"
                                                    size="14"
                                                    className="icon me-1" />

                                                <span>Reset</span>
                                            </button>
                                            <button
                                                type="submit"
                                                className={`st-btn st-btn-primary d-flex st-btn-sm no-min-width align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                                disabled={createButtonDisable}
                                                onClick={handleFormSubmission}
                                            >
                                                <FeatherIcon
                                                    icon="download"
                                                    size="14"
                                                    className="icon me-1" />

                                                <span>Save</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                modalLoading && (
                                    <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                        <Spinner animation="border" />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <button type="submit" ref={submitButtonRef} className="d-none">submit</button>

                </form>
            </Modal.Body>
        </Modal>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddShippingAddressModal)
